module.exports = __webpack_public_path__ + "img/experience.5116e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutMe_img/experience.jpg
// module id = M3Ak
// module chunks = 0